export const theme = {
  colors: {
    primary: '#0070f3',
    secondary: '#ff0070',
    accent: '#855988',
  },
};

// 855988	6B4984	483475	2B2F77	141852	070B34
